module.exports = "/_next/static/resources/photo-2-39e8784b597521bb1dc1d387027f7a2e.jpg";